import * as types from "../actions/actionsTypes";
import initialState from "./initialState";

export default function incidentReportStatusDataReducer(state = initialState.incidentReportStatusData, action) {
  switch (action.type) {
    case types.LOAD_INCIDENT_REPORT_STATUS_DATA_SUCCESS:
      return action.incidentReportStatusData;
    default:
      return state;
  }
}
